/**
 * @author Fernando Ruano
 * @file actions.js
 * @description Parameter Actions
 */
// Constants
import {
  GET_ALL_PARAMETERS,
  CREATE_PARAMETER,
  UPDATE_PARAMETER,
  GET_PARAMETER_BY_ID,
  GET_PARAMETER_BY_KEY,
  DELETE_PARAMETER_BY_ID,
  GET_MULTIPLE_PARAMETER_BY_KEY
} from './constants';

/**
 * Call process to get all parameters list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_ALL_PARAMETERS
 */
export const getParametersArray = (data, callback) => ({
  type: GET_ALL_PARAMETERS,
  payload: { data },
  callback
});

/**
 * Call process to get parameter by id
 * @param  { object } data - Parameter Id
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_ROL_BY_ID
 */
export const getParameterById = (data, callback) => ({
  type: GET_PARAMETER_BY_ID,
  payload: { data },
  callback
});

/**
 * Call process to get parameter by key
 * @param  { object } data - Parameter key
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_PARAMETER_BY_KEY
 */
export const getParameterByKey = (data, callback) => ({
  type: GET_PARAMETER_BY_KEY,
  payload: { data },
  callback
});

/**
 * Call process to get multiple parameters by key
 * @param  { object } data - Parameter key array
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_MULTIPLE_PARAMETER_BY_KEY
 */
export const getMultipleParameterByKey = (data, callback) => ({
  type: GET_MULTIPLE_PARAMETER_BY_KEY,
  payload: { data },
  callback
});

/**
 * Call process to create parameter
 * @param  { object } data - Parameter Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of CREATE_PARAMETER
 */
export const createParameter = (data, callback) => ({
  type: CREATE_PARAMETER,
  payload: { data },
  callback
});

/**
 * Call process to update parameter
 * @param  { object } data - Parameter Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of UPDATE_PARAMETER
 */
export const updateParameter = (data, callback) => ({
  type: UPDATE_PARAMETER,
  payload: { data },
  callback
});

/**
 * Call process to delete parameter
 * @param  { object } data - Parameter Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of UPDATE_PARAMETER
 */
export const deleteParameterById = (data, callback) => ({
  type: DELETE_PARAMETER_BY_ID,
  payload: { data },
  callback
});
